export class User {
  id!: number;
  email!: string;
  name!: string;
  confirmed = false;
  createdAt!: string;
  ssoProviders: string[] = [];
  superadmin = false;
  twoFactorEnabled = false;
  preferences: Record<string, unknown> | null = null;

  constructor(data: any = {}) {
    this.id = data.id;
    this.email = data.email;
    this.name = data.name;
    this.confirmed = !!data.confirmed;
    this.createdAt = data.created_at;
    this.ssoProviders = data.sso_providers ?? [];
    this.superadmin = !!data.superadmin;
    this.twoFactorEnabled = !!data.two_factor_enabled;
    this.preferences = isObject(data.preferences) ? data.preferences : null;
  }
}

function isObject(v: unknown): v is Record<string, unknown> {
  return !!v && typeof v === 'object' && !Array.isArray(v);
}
